var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc_bread-nav"},[_c('div',{staticClass:"nav-main"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/blogList' }}},[_vm._v("Blog")]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$t('blog.blogDetail.64wgr171wdx9')))])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }